import api from './api';

export type AIJobType = 'schedule_opt' | 'video_analyzer' | 'delay' | 'overall_report' | 'risk_forecast';

export interface AIJobCreate {
  type: AIJobType;
  task_id: string;
  data_key: string;
  meta?: {
    fileName?: string;
    videoFileName?: string;
    imageCount?: number;
  };
}

export const aiJobsService = {
  async create(payload: AIJobCreate) {
    return api.post('/ai-jobs', payload);
  },
  async list(type?: AIJobType) {
    return api.get('/ai-jobs', { params: type ? { type } : {} });
  },
};